import { ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

export const TableWrapper = ({ children, classes }: { children: ReactNode; classes?: string }) => (
  <div className={twMerge('relative z-[1] border border-canvas-primary-main m-4', classes)}>{children}</div>
);
